import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, toDisplayString as _toDisplayString, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, normalizeClass as _normalizeClass, withKeys as _withKeys, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = ["data-testid"]
const _hoisted_2 = { class: "flex justify-between items-start w-full" }
const _hoisted_3 = { class: "bg-primary30 rounded-[11.2px] p-2.5" }
const _hoisted_4 = {
  viewBox: "0 0 24 24",
  fill: "white",
  class: "w-6 h-6",
  "aria-hidden": "true"
}
const _hoisted_5 = ["d"]
const _hoisted_6 = {
  viewBox: "0 0 24 24",
  fill: "currentColor",
  class: "w-6 h-6 text-primary30",
  "aria-hidden": "true"
}
const _hoisted_7 = ["d"]
const _hoisted_8 = { class: "flex flex-col flex-1" }
const _hoisted_9 = { class: "flex items-center gap-2 text-primary50 font-bold text-base leading-6 tracking-[0.08px]" }
const _hoisted_10 = { class: "text-[#52526F] text-sm leading-[18px] tracking-[0.07px]" }
const _hoisted_11 = ["data-testid"]
const _hoisted_12 = /*#__PURE__*/_createElementVNode("span", {
  class: "h-7 w-10 rounded bg-slate-200 animate-pulse",
  "aria-hidden": "true"
}, null, -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("span", { class: "sr-only" }, "Carregando contagem", -1)
const _hoisted_14 = { class: "text-sm leading-[18px] text-[#52526F]" }
const _hoisted_15 = ["data-testid"]
const _hoisted_16 = {
  key: 0,
  viewBox: "0 0 24 24",
  fill: "currentColor",
  class: "w-4 h-4 shrink-0",
  "aria-hidden": "true"
}
const _hoisted_17 = ["d"]
const _hoisted_18 = ["data-testid"]
const _hoisted_19 = {
  viewBox: "0 0 24 24",
  fill: "currentColor",
  class: "w-4 h-4 shrink-0",
  "aria-hidden": "true"
}
const _hoisted_20 = ["d"]

import { computed } from 'vue'
import { mdiAlertCircleOutline, mdiChevronRight } from '@mdi/js'

import LabelBadge from '@/components/designSystem/Badges/LabelBadge.vue'

const DISPLAY_FALLBACK = '—'


export default /*#__PURE__*/_defineComponent({
  __name: 'ApprovalQueueCard',
  props: {
    icon: {},
    title: {},
    description: {},
    countLabel: {},
    count: {},
    isLoading: { type: Boolean, default: false },
    errorMessage: { default: null },
    badge: { default: null },
    footerText: { default: null },
    footerIcon: { default: null },
    footerVariant: { default: 'default' },
    testId: {}
  },
  emits: ["click"],
  setup(__props: any, { emit }) {

const props = __props;





const countLabelText = computed(() => {
  if (props.count === null) return 'contagem indisponível'
  return props.count === 0 ? 'nada aguardando' : props.countLabel
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    role: "button",
    tabindex: "0",
    class: "flex flex-col gap-2 p-4 h-full w-full border border-primary30 rounded-lg cursor-pointer bg-white hover:shadow-md transition-shadow text-left focus:outline-none focus-visible:ring-2 focus-visible:ring-primary30",
    "data-testid": _ctx.testId,
    onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('click'))),
    onKeydown: [
      _cache[1] || (_cache[1] = _withKeys(($event: any) => (emit('click')), ["enter"])),
      _cache[2] || (_cache[2] = _withKeys(_withModifiers(($event: any) => (emit('click')), ["prevent"]), ["space"]))
    ]
  }, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (_openBlock(), _createElementBlock("svg", _hoisted_4, [
          _createElementVNode("path", { d: _ctx.icon }, null, 8, _hoisted_5)
        ]))
      ]),
      (_openBlock(), _createElementBlock("svg", _hoisted_6, [
        _createElementVNode("path", { d: _unref(mdiChevronRight) }, null, 8, _hoisted_7)
      ]))
    ]),
    _createElementVNode("div", _hoisted_8, [
      _createElementVNode("span", _hoisted_9, [
        _createTextVNode(_toDisplayString(_ctx.title) + " ", 1),
        (_ctx.badge)
          ? (_openBlock(), _createBlock(LabelBadge, {
              key: 0,
              label: _ctx.badge,
              color: "blue",
              size: "small",
              icon: null
            }, null, 8, ["label"]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.description), 1),
      _createElementVNode("div", {
        class: "mt-3 flex items-baseline gap-2 min-h-[32px]",
        "data-testid": `${_ctx.testId}-count`
      }, [
        (_ctx.isLoading)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _hoisted_12,
              _hoisted_13
            ], 64))
          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              _createElementVNode("strong", {
                class: _normalizeClass(["text-2xl leading-8 font-bold tabular-nums", _ctx.count ? 'text-primary50' : 'text-neutral50'])
              }, _toDisplayString(_ctx.count ?? DISPLAY_FALLBACK), 3),
              _createElementVNode("span", _hoisted_14, _toDisplayString(countLabelText.value), 1)
            ], 64))
      ], 8, _hoisted_11)
    ]),
    (_ctx.footerText)
      ? (_openBlock(), _createElementBlock("span", {
          key: 0,
          class: _normalizeClass(["flex items-center gap-1 text-sm leading-[18px]", _ctx.footerVariant === 'alert' ? 'text-alert font-medium' : 'text-[#52526F]']),
          "data-testid": `${_ctx.testId}-footer`
        }, [
          (_ctx.footerIcon)
            ? (_openBlock(), _createElementBlock("svg", _hoisted_16, [
                _createElementVNode("path", { d: _ctx.footerIcon }, null, 8, _hoisted_17)
              ]))
            : _createCommentVNode("", true),
          _createTextVNode(" " + _toDisplayString(_ctx.footerText), 1)
        ], 10, _hoisted_15))
      : _createCommentVNode("", true),
    (!_ctx.isLoading && _ctx.errorMessage)
      ? (_openBlock(), _createElementBlock("span", {
          key: 1,
          class: "flex items-center gap-1 text-xs text-neutral50",
          "data-testid": `${_ctx.testId}-error`
        }, [
          (_openBlock(), _createElementBlock("svg", _hoisted_19, [
            _createElementVNode("path", { d: _unref(mdiAlertCircleOutline) }, null, 8, _hoisted_20)
          ])),
          _createTextVNode(" " + _toDisplayString(_ctx.errorMessage), 1)
        ], 8, _hoisted_18))
      : _createCommentVNode("", true)
  ], 40, _hoisted_1))
}
}

})